import React from 'react';
import { classes } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { telemetryConsumerWrapper } from '~src/commonInfra/telemetryEvents/contexts/TelemetryConsumerWrapper';
import { ContentClickedTelemetryContext } from '~src/commonInfra/telemetryEvents/contexts/TelemetryContexts';
import { ContentClickedEventHandler } from '~src/commonInfra/telemetryEvents/types/ContentTelemetryTypes';
import { mouseUpFactory } from '~src/commonInfra/telemetryEvents/util/EventHandlerFactories';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CommonTableInfo } from '~src/spacesPlatform/models/CommonTableInfo';
import { CardResizerService, CustomThumbnailTextTestId } from '~src/spacesPlatform/services/CardResizerService';

export type TableThumbnailProps = Pick<React.AriaAttributes, 'aria-label'> & {
    readonly allowDragAndDrop: boolean;
    readonly content: CommonTableInfo;
    readonly contentUrl?: string;
    readonly hovered?: boolean;
    readonly selected?: boolean;
    readonly cardZoomPercentage: number;
}

export class TableThumbnail extends React.Component<TableThumbnailProps> {
    public render() {
        const tableContent = this.props.content;
        const isDbServer: boolean = tableContent.dbType === 'DatabaseServer';
        const imgUrl = imgPath('table_card.svg');
        const thumbnailSecondTitle = isDbServer ? Messages.tableCardHostname() + tableContent.hostName : Messages.tableCardFilepath() + tableContent.filePath;

        /* eslint-disable jsx-a11y/alt-text */
        return (
            <div className={classes(CardViewStyles.CustomThumbnail, {
                [CardViewStyles.SelectedClassName]: this.props.selected,
                [CardViewStyles.HoveredClassName]: this.props.hovered && !this.props.selected
            })} style={{ zoom: this.props.cardZoomPercentage }}>
                <div className={CardViewStyles.CustomThumbnailTopContainer}>
                    <div className={CardViewStyles.DatabaseCustomThumbnailImg}>
                        <img src={imgUrl}
                            width={'60px'} height={'60px'}
                            data-tb-test-id='table-icon' />
                    </div>
                    <div data-tb-test-id={CustomThumbnailTextTestId} style={{ zoom: CardResizerService.instance.getCardZoomPercentageForCustomThumbailText() }}>{isDbServer ? Messages.database() + ': ' + tableContent.databaseName : Messages.fileName() + ': ' + tableContent.fileName}</div>
                    <div data-tb-test-id={CustomThumbnailTextTestId} className={CardViewStyles.DatabaseCustomSecondTitle} style={{ zoom: CardResizerService.instance.getCardZoomPercentageForCustomThumbailText() }}>{thumbnailSecondTitle}</div>
                </div>
                {this.props.contentUrl &&
                    telemetryConsumerWrapper(ContentClickedTelemetryContext.Consumer, (sendOpenContentTelemetry: ContentClickedEventHandler) =>
                        /* eslint-disable jsx-a11y/anchor-has-content */
                        <a
                            onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)}
                            href={this.props.contentUrl}
                            className={classes(CardViewStyles.AnchorUnderlay, CardViewStyles.ThumbnailFocus)}
                            draggable={this.props.allowDragAndDrop ? false : undefined}
                            aria-label={this.props['aria-label']}
                        ></a>
                    )
                }
            </div>
        );
    }

}
